// extracted by mini-css-extract-plugin
module.exports = {"container":"CardTextA_container__1zV9B","heading":"CardTextA_heading__egAUj","contentMarkup":"CardTextA_contentMarkup__29vyq"};